import React from "react";
import { connect } from "react-redux";
import { CartIcon, MenuIcon, SearchIcon } from "./Icons";
import Logo from "./Logo";
import { toggleVisibility } from "../../Redux/slices/cart";
import { toggleMainMenu } from "../../Redux/slices/menu";
import { toggleSearchVisible } from "../../Redux/slices/search";
import DesktopSearch from "./Search/DesktopSearch";

const mapDispatchToProps = dispatch => {
    return {
        toggleCart: payload => dispatch(toggleVisibility(payload)),
        toggleMainMenu: payload => dispatch(toggleMainMenu(payload)),
        toggleSearchVisible: payload => dispatch(toggleSearchVisible(payload))
    }
}

class Header extends React.Component {
    render() {
        return <div className="header-wrap">
            <div className="header-nav">
                <div className="section">
                    <MenuIcon onClick={() => this.props.toggleMainMenu(true)}>
                        <span className="icon-label">Menu</span>
                    </MenuIcon>
                </div>

                <Logo />

                <div className="section end">
                    <SearchIcon onClick={() => this.props.toggleSearchVisible()}>
                        <span className="icon-label">Search</span>
                    </SearchIcon>

                    <DesktopSearch />

                    <CartIcon onClick={() => this.props.toggleCart(true)}>
                        <span className="icon-label">Cart</span>
                    </CartIcon>
                </div>
            </div>
        </div>
    }
}

export default connect(null, mapDispatchToProps)(Header);